<div class="edit-page-root-container employee-job-title-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit || permission.can_add){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" [readonly]="itemInfo.id!==undefined && itemInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code is required</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is 50.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" [readonly]="itemInfo.id!==undefined && itemInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name is required</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is 100.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div style="flex: 1;">
                                <mat-form-field style="width: 100%;">
                                    <mat-label>Job Position</mat-label>
                                    <mat-select formControlName="job_position_id" [disabled]="itemInfo.id!==undefined && itemInfo.id!==0">
                                        @for(pos of jobPositions; track pos.id){
                                        <mat-option [value]="pos.id">{{pos.name}}</mat-option>
                                        }
                                    </mat-select>
                                    <mat-error *ngIf="editForm.controls['job_position_id'].hasError('required')">Job Position is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left" style="display: flex; align-items: center; gap: 20px; padding-bottom: 20px;">
                                <mat-checkbox formControlName="is_hq" [disabled]="itemInfo.id!==undefined && itemInfo.id!==0">Is HQ</mat-checkbox>
                                <mat-checkbox formControlName="is_active" [disabled]="itemInfo.id!==undefined && itemInfo.id!==0">Is Active</mat-checkbox>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" [readonly]="itemInfo.id!==undefined && itemInfo.id!==0"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
